/** IDs estables — mirror de WORK_MODULES. */
export const PANEL_MODULE_VISOR = "visor_sat";
export const PANEL_MODULE_LABORAL = "asistente_laboral";
export const PANEL_MODULE_TRAMITES = "tramites_fiscales";
export const PANEL_MODULE_DESPACHO = "gestion_despacho";
export const PANEL_MODULE_DISENADOR = "disenador";

/** Módulos del Panel General que exigen entitlement activo para «Entrar» (Fase 3F-A). */
export const PANEL_ENTITLEMENT_GATED_MODULES = new Set([
  PANEL_MODULE_VISOR,
  PANEL_MODULE_LABORAL,
  PANEL_MODULE_TRAMITES,
  PANEL_MODULE_DESPACHO,
]);

/**
 * Mirror acotado de resolveHubModuleAccess (tests Jest sin cadena @/).
 * Mantener alineado con routeEntitlementGuard / moduleAccess.
 */
function isPanelModuleEntitled(cardId, accessCtx = {}) {
  if (accessCtx.isPlatformDesigner) return true;
  const ent = accessCtx.entitlements || {};
  const visor = accessCtx.modulo_visor_sat;
  const laboral = accessCtx.modulo_asistente_laboral;
  const tramites = accessCtx.modulo_tramites_fiscales;
  const despacho = accessCtx.modulo_gestion_despacho;

  if (cardId === PANEL_MODULE_VISOR) {
    if ("visor" in ent) return Boolean(ent.visor);
    return visor !== false;
  }
  if (cardId === PANEL_MODULE_LABORAL) {
    if ("laboral" in ent) return Boolean(ent.laboral);
    return Boolean(laboral);
  }
  if (cardId === PANEL_MODULE_TRAMITES) {
    if ("tramites" in ent) return Boolean(ent.tramites);
    return Boolean(tramites ?? visor ?? true);
  }
  if (cardId === PANEL_MODULE_DESPACHO) {
    if ("despacho" in ent) return Boolean(ent.despacho);
    return Boolean(despacho);
  }
  return true;
}

/**
 * Resuelve si el clic «Entrar al módulo» debe navegar o bloquearse.
 * Diseñador y tarjetas fuera del set conservan el flujo previo.
 *
 * @param {string} cardId
 * @param {object} accessCtx — mismo shape que resolveHubModuleAccess en PanelGeneral
 * @returns {{ allowed: boolean, reason?: 'loading' | 'no_entitlement' }}
 */
export function resolvePanelHubEntry(cardId, accessCtx = {}) {
  if (!PANEL_ENTITLEMENT_GATED_MODULES.has(cardId)) {
    return { allowed: true };
  }
  if (accessCtx.permLoading) {
    return { allowed: false, reason: "loading" };
  }
  if (isPanelModuleEntitled(cardId, accessCtx)) {
    return { allowed: true };
  }
  return { allowed: false, reason: "no_entitlement" };
}
